import { documentIsHidden } from "./whenDocumentVisible";

export const VISIBLE_GRACE_MS = 10000;

export function createChatLiveness({ timeoutMs, isActive, onTimeout }) {
  let deadlineAt = 0;
  let timerId = null;
  let disposed = false;

  const clearTimer = () => {
    if (timerId) {
      clearTimeout(timerId);
      timerId = null;
    }
  };

  const dispose = () => {
    if (disposed) return;
    disposed = true;
    clearTimer();
    document.removeEventListener("visibilitychange", onVisibility);
  };

  const fireIfDue = () => {
    if (disposed || !isActive()) return;
    if (documentIsHidden()) return;
    if (Date.now() < deadlineAt) {
      schedule();
      return;
    }
    dispose();
    onTimeout();
  };

  const schedule = () => {
    clearTimer();
    if (disposed || !isActive()) return;
    if (documentIsHidden()) return;
    const now = Date.now();
    const dueAt = now < deadlineAt ? deadlineAt : deadlineAt + VISIBLE_GRACE_MS;
    timerId = setTimeout(fireIfDue, Math.max(dueAt - now, 0));
  };

  const bump = () => {
    if (disposed) return;
    deadlineAt = Date.now() + timeoutMs;
    schedule();
  };

  const onVisibility = () => {
    if (disposed || !isActive()) return;
    if (documentIsHidden()) {
      clearTimer();
      return;
    }
    schedule();
  };

  document.addEventListener("visibilitychange", onVisibility);
  bump();

  return { bump, schedule, dispose };
}
